import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Loading } from "@bluframe/blublocks";
import { DraftsList as UIDrafts, Pagination, Typography } from "@bluframe/mightychroma-mightytool-ui";
import { Wrapper } from "./styled";
const News = ({ drafts, isAdmin, isEditor, loading, pagination }) => (_jsxs(Wrapper, { children: [_jsx(Typography.H1, { children: "News Drafts" }), _jsx(Pagination, { ...pagination }), loading ? _jsx(Loading, { size: 24 }) : null, drafts ? (_jsx(UIDrafts, { drafts: drafts, isAdmin: isAdmin, isEditor: isEditor })) : null, _jsx(Pagination, { ...pagination })] }));
export default News;
